import { render, staticRenderFns } from "./addOredit.vue?vue&type=template&id=705e7878&scoped=true&"
import script from "./addOredit.vue?vue&type=script&lang=js&"
export * from "./addOredit.vue?vue&type=script&lang=js&"
import style0 from "./addOredit.vue?vue&type=style&index=0&id=705e7878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705e7878",
  null
  
)

export default component.exports